import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, Typography } from '@mui/material'
import { NumericInput, TextField } from '@carsys/form'
import { useTicketFormContext } from '@cbgms/components/src/support-request/context/TicketFormContext'

export const PartFormFields = ({ preFilled }: { preFilled: boolean }) => {
  const { t } = useTranslation()
  const { clearPartValues } = useTicketFormContext()

  // Clear Part fields when these get unmounted
  useEffect(() => () => clearPartValues(), [])

  return (
    <Grid container direction='column' spacing={1.5}>
      <Grid item>
        <Typography variant='h5' gutterBottom>
          {t('Contact.PartInformation')}
        </Typography>
      </Grid>
      <Grid item>
        <Grid container direction='row' spacing={1}>
          <Grid item xs={12}>
            <TextField label={t('Contact.PartName')} disabled={preFilled} name='Part.Description' required />
          </Grid>
          <Grid item xs={6}>
            <TextField label={t('Contact.PartID')} disabled={preFilled} name='Part.BaseID' required />
          </Grid>
          <Grid item xs={6}>
            <TextField label={t('Contact.PartBrand')} disabled={preFilled} name='Part.Brand' required />
          </Grid>
          <Grid item xs={6}>
            <NumericInput label={t('product.quantity')} type='number' required name='Part.Quantity' />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
